import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function SobreScreen() {
  const navigate = useNavigate();

  return (
    <div style={{ maxWidth: 700, margin: '0 auto', paddingTop: 32, paddingBottom: 48 }}>
      <div style={{ textAlign: 'center', marginBottom: 32 }}>
        <img 
          src="/assets/logos-07.svg" 
          alt="Logo Currículo Popular" 
          style={{ width: 100, height: 100, marginBottom: 16 }} 
        />
        <h1 style={{ 
          color: 'var(--primary-color)', 
          fontWeight: 700, 
          fontSize: 28, 
          marginBottom: 8 
        }}>
          Nossa História
        </h1>
      </div>

      <div style={{ 
        backgroundColor: '#f8f9fa', 
        borderRadius: 12, 
        padding: 32, 
        lineHeight: 1.8,
        fontSize: 16,
        color: 'var(--text-color)'
      }}>
        <p style={{ marginBottom: 20 }}>
          O <strong>Currículo Popular</strong> nasceu de um ideal simples e poderoso: 
          <em> todos devem ter a oportunidade de alcançar seus empregos</em>, independentemente 
          de seus recursos ou condições.
        </p>

        <p style={{ marginBottom: 20 }}>
          Tudo começou em <strong>2018</strong>, quando Aryon precisava imprimir um currículo 
          e pediu ajuda ao fundador do projeto. Ao ver o documento, Linus percebeu que estava 
          muito mal formatado e faltando informações essenciais. Sem hesitar, Linus refez 
          completamente o currículo de Aryon.
        </p>

        <p style={{ marginBottom: 20 }}>
          O resultado foi imediato e transformador: <strong>Aryon foi empregado no dia seguinte</strong>.
        </p>

        <p style={{ marginBottom: 20 }}>
          Desde aquele momento, o projeto cresceu de forma orgânica e impactante. 
          Já foram mais de <strong>1.000 currículos manufaturados</strong> e <strong>milhares 
          de pessoas empregadas</strong> com a ajuda do Currículo Popular.
        </p>

        <p style={{ marginBottom: 20 }}>
          Além dos currículos, desde 2018 o Currículo Popular cresceu e recebeu <strong>diversos 
          voluntários e parceiros</strong> que acreditam na mesma causa. Em <strong>2023</strong>, 
          o projeto foi reconhecido ao <strong>ganhar o Hackathon de Gravataí</strong>, consolidando 
          ainda mais sua missão de transformar vidas através do acesso ao mercado de trabalho.
        </p>

        <p style={{ marginBottom: 0 }}>
          O Currículo Popular é um <strong>voluntariado</strong> dedicado a fabricar currículos
          <strong> gratuitamente</strong>, devolvendo-os prontos em PDF para quem mais precisa, 
          garantindo dignidade e competitividade no mercado de trabalho.
        </p>
      </div>

      <div style={{ textAlign: 'center', marginTop: 32 }}>
        <button
          className="btn btn-primary"
          onClick={() => navigate('/')}
          style={{ fontSize: 16, padding: '12px 32px' }}
        >
          Voltar ao Início
        </button>
      </div>
    </div>
  );
}
